import React from 'react';
import {Link} from 'react-router-dom';
import {useRecoilValue, useResetRecoilState, useSetRecoilState} from 'recoil';
import colorDeclarationTemp from '../../utilis/colorDeclarationTemp';
import formattedDate from '../../utilis/formatDate';
import {minimizeText} from '../../utilis/minimizeText';
import useFetchColorDeclarations from '../../hooks/useFetchColorDeclarations';
import {colorDeclarationsFiltered, colorDeclarationsFilterNumber} from '../../state/colorDeclarations';
import ColorDeclarationType from '../../types/ColorDeclarationType';
import UICard from '../UICommon/UICard';
import UICardHeader from '../UICommon/UICardHeader';
import UIChip from '../UICommon/UIChip';
import UILoadingIndicator from '../UICommon/UILoadingIndicator';
import UIErrorIndicator from '../UICommon/UIErrorIndicator';
import UINoDataIndicator from '../UICommon/UINoDataIndicator';

const ColorDeclarationCreatedCard: React.FC = () => {
  const {isLoading, isError} = useFetchColorDeclarations();
  const setDeclarationFilterNumber: any = useSetRecoilState(colorDeclarationsFilterNumber);
  const deleteFilterNumber: any = useResetRecoilState(colorDeclarationsFilterNumber);
  const declarationFilterNumber: any = useRecoilValue(colorDeclarationsFilterNumber);
  const colorDeclarationsData: any = useRecoilValue(colorDeclarationsFiltered);

  const setFilter = (filterNumber: number) => {
    if (filterNumber === declarationFilterNumber) {
      deleteFilterNumber();
    } else {
      setDeclarationFilterNumber(filterNumber);
    }
  };
  return (
    <UICard style="md:max-h-[72vh] pb-10 md:pb-0 md:px-2">
      <span className='md:hidden'>
        <UICardHeader
          title="Färgdeklarationer"
          padding={false}
          description='Här hittar du dina tidigare färgdeklarationer.'
        />
      </span>
      <span className='hidden md:block'>
        <UICardHeader
          title="Färgdeklarationer"
          description='Här hittar du dina tidigare färgdeklarationer.'
        />
      </span>
      {isLoading ? <UILoadingIndicator/> : isError ? <UIErrorIndicator/> : (
        <>
          <div className='flex space-x-2 md:px-5 pb-5'>
            {colorDeclarationTemp?.timelineChips?.map((el: any) => (
              <UIChip
                key={el?.filterNumber}
                element={el}
                text={el?.text}
                type="white"
                onClick={() => setFilter(el?.filterNumber)}
                isSelected={el?.filterNumber === declarationFilterNumber}/>
            ))}
          </div>
          {!colorDeclarationsData || colorDeclarationsData.length == 0 ?
              <UINoDataIndicator message='Du har inga färgdeklarationer.'/> : (
            <>
              <div className='pb-5'>
                <div className='px-2 flex'>
                  {colorDeclarationTemp.tableLabels.map((el: { text: string; }, idx: number) => (
                    <div key={idx} className="font-semibold text-xs flex-1 text-center">{el.text}</div>
                  ))}
                </div>
              </div>
              <div className='px-2 md:px-3 space-y-2 pt-4 pb-2 overflow-y-scroll h-2/3'>
                {colorDeclarationsData?.map((el: ColorDeclarationType, idx: number) => (
                  <React.Fragment key={idx}>
                    {el.status.toLowerCase() === 'draft' ? (
                      <Link
                        to={`/fargdeklaration/${el.id}/new`}
                        className={
                          'rounded-md shadow-thin-card w-full bg-white py-3 px-4 text-xs font-Outfit flex ' +
                          'justify-between items-center'}
                      >
                        <span className='w-1/3'>{minimizeText(el.name, 20)}</span>
                        <span className='w-[10%]'>{el.colors.length}</span>
                        <span className='w-1/3 text-center'>{formattedDate(el.created_at)}</span>
                        <span className={
                          'bg-pink-background border-pink-border text-pink-text ' +
                          'border w-12 py-1 text-center rounded'}>
                          Utkast
                        </span>
                      </Link>
                    ) : (
                      <div className={
                        'rounded-md shadow-thin-card w-full bg-white py-3 px-4 text-xs font-Outfit flex ' +
                        'justify-between items-center'}
                      >
                        <span className='w-1/3'>{minimizeText(el.name, 20)}</span>
                        <span className='w-[10%]'>{el.colors.length}</span>
                        <span className='w-1/3 text-center'>{formattedDate(el.created_at)}</span>
                        <span className={
                          'bg-green-background text-green-text border-green-border ' +
                          'border w-12 py-1 text-center rounded'}>
                          Färdig
                        </span>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </>
            )}
        </>
      )}
    </UICard>
  );
};

export default ColorDeclarationCreatedCard;
